import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/acc_account'

const deleteAccounts = async function(id) {
    try {
        let response = await axios.delete(route + '/' + id)
        return response.data
    } catch (error) {
        return error.response.data
    }
}

export default deleteAccounts
